<app-post-not-found *ngIf="postsDisplay.length<1 && !loading"></app-post-not-found>
<app-spinner *ngIf="loading"></app-spinner>
<ng-container *ngIf="!loading">
  <div *ngFor="let post of postsDisplay" class="post__wrapper" [ngClass]=" moderatorMode ? 'moderator' : ''">
    <app-post-display [post]="post" (updatePost)="updatePost.emit($event)" (deletePost)="deletePost.emit($event)"
                      (renewPost)="renewPost.emit($event)"></app-post-display>

    <app-moderator *ngIf="moderatorMode" [post]="post" (validatePost)="validatePost.emit($event)"
                   (invalidatePost)="invalidatePost.emit($event)" (updatePost)="updatePost.emit($event)"
                   (deletePost)="deletePost.emit($event)"></app-moderator>
  </div>
  <span *ngIf="scrollLoad" class="loaded"></span>
</ng-container>

